import axios from 'axios';
import React,{useState,useEffect} from 'react';
import Select from "react-select";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const AddWorkSpaceMemberModal = ({ isOpen, onClose,workspaceName,workSpaceId,fetchLabGroups }) => {
      const [users, setUsers] = useState([]); // ✅ initialize as array
      const [selectedUser, setSelectedUser] = useState(null);
      const [loading, setLoading] = useState(false)
      useEffect(() => {
          const fetchUsers = async () => {
              try {
                  const res = await axios.get(
                      `${BASE_URL}/marketplace/university/user-profiles/`,
                      {
                          headers: {
                              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                              "x-api-key": process.env.REACT_APP_X_API_KEY,
                          },
                      }
                  );
  
                  // ✅ handle paginated OR normal response
                  setUsers(res.data.results || res.data || []);
              } catch (error) {
                  console.log("Error while getting profiles", error);
                  setUsers([]);
              }
          };
  
          fetchUsers();
      }, []);
      const options = users.map((user) => ({
        value: user.profile_id || user.id,
        label: `${user.name || user.full_name} (${user.email})`
    }));
const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "#f9fafb",
            borderColor: state.isFocused ? "#0f6abf" : "#d1d5db",
            borderRadius: "0.75rem",
            padding: "6px",
            boxShadow: state.isFocused ? "0 0 0 2px rgba(15,106,191,0.2)" : "none",
            "&:hover": {
                borderColor: "#0f6abf"
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#e6f0fa"
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#0f6abf",
            fontWeight: "500"
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#0f6abf",
            ":hover": {
                backgroundColor: "#0f6abf",
                color: "white"
            }
        })
    };
 const handleSubmit = async (e) => {
        e.preventDefault();
        if(!workSpaceId) return alert('group id is required')
        if (selectedUser.length === 0) return alert('select user please');
        console.log(selectedUser)
       setLoading(true)
       try {
         const response = await axios.post(
                `${BASE_URL}/marketplace/industry/workspace/member/`,
                 {
                   profile_ids:selectedUser,
                   workspace:workSpaceId
                 },
               {
                 headers: {
                     Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                     "x-api-key": process.env.REACT_APP_X_API_KEY,
                   },
               }
             );
             if(response.status === 201)
             {
                  alert('WorkSpace member created successfully')
                  fetchLabGroups()
                 onClose()
                 setSelectedUser(null)
             }
       } catch (error) {
         console.log("error while creating lab group member",error)
       } finally {
        setLoading(false)
       }

    }
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl flex flex-col h-[500px]">

        {/* HEADER */}
        <div className="flex justify-between items-center p-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <h2 className="text-sm font-semibold text-gray-900">
                  Add WorkSpace Member
              </h2>
              <p className="text-xs text-gray-500"> Fill in the details below to add a new workspace member to your this workspapce {workspaceName}.</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
          >
            <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
    {/* Form */}
                <form className="space-y-6 p-6" onSubmit={handleSubmit}>
                    {/* Department Name */}
                    {/* Head of Department */}
                    <div>
                        <div className="flex items-center gap-2 mb-3">
                            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                            <label className="text-sm font-semibold text-gray-700">
                                Select WorkSpace Members
                            </label>
                        </div>
                        <div className="relative">
                            <Select
                                options={options}
                                isMulti
                                value={selectedUser}
                                onChange={setSelectedUser}
                                placeholder="Select workspace member or members"
                                styles={customStyles}
                            />
                        </div>
                    </div>
                  
                   
                    <button
                        className="mt-4 w-full bg-[#0f6abf] text-white py-3 rounded-xl font-medium hover:bg-[#0a5ca8] transition-all disabled:opacity-50 flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <>
                                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                <span>Adding WorkSpace Members...</span>
                            </>
                        ) : (
                            <>
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                                </svg>
                                Add WorkSpace Members
                            </>
                        )}
                    </button>
                </form>
      </div>
    </div>
  );
};

export default AddWorkSpaceMemberModal;